import { createAuthClient } from "better-auth/client";
import { twoFactorClient } from "better-auth/client/plugins";
import { getB3ApiUrl } from "../app.shared.js";
export function createB3BetterAuthClient(baseURL) {
    return createAuthClient({
        baseURL: baseURL ?? getB3ApiUrl(),
        basePath: "/auth",
        fetchOptions: {
            credentials: "include",
        },
        plugins: [twoFactorClient()],
    });
}
// Lazily-initialized singleton. Recreated when the API URL changes via
// `resetBetterAuthClient()` (called by B3Provider when `apiUrl` changes).
let _client = null;
let _clientUrl = null;
/** Get the shared BetterAuth client, creating it if needed. */
export function getBetterAuthClient() {
    const url = getB3ApiUrl();
    if (!_client || _clientUrl !== url) {
        _client = createB3BetterAuthClient(url);
        _clientUrl = url;
    }
    return _client;
}
/** Force-recreate the client on next access (e.g. after API URL change). */
export function resetBetterAuthClient() {
    _client = null;
    _clientUrl = null;
}
/**
 * @deprecated Use `getBetterAuthClient()` instead. This static singleton
 * does not reflect runtime API URL changes via `B3Provider apiUrl` prop.
 */
export const betterAuthClient = createB3BetterAuthClient();
